import { Language } from '@metadevprofile/shared';
import { use } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import * as en from './en';
import * as fr from './fr';

export const LANGUAGES = {
  [Language.EN]: 'English',
  [Language.FR]: 'Français',
} as const;

export const NAMESPACES = {
  common: 'common',
  agent: 'agent',
  auth: 'auth',
  changelog: 'changelog',
  evaluation: 'evaluation',
  institution: 'institution',
  media: 'media',
  notification: 'notification',
  onboarding: 'onboarding',
  patient: 'patient',
  practitioner: 'practitioner',
  profile: 'profile',
  subscription: 'subscription',
  'admin-user': 'admin-user',
  'admin-institution': 'admin-institution',
  'app-version': 'app-version',
};

export type Namespace = keyof typeof NAMESPACES;

export const DEFAULT_LANGUAGE: Language = Language.FR;
export const DEFAULT_NAMESPACE: Namespace = 'common';

const i18n = use(LanguageDetector).use(initReactI18next);

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

i18n.init({
  ns: Object.values(NAMESPACES),
  defaultNS: DEFAULT_NAMESPACE,
  fallbackNS: DEFAULT_NAMESPACE,
  fallbackLng: Language.FR,
  supportedLngs: [Language.EN, Language.FR],
  resources: {
    [Language.EN]: {
      common: en.common,
      agent: en.agent,
      auth: en.auth,
      changelog: en.changelog,
      evaluation: en.evaluation,
      institution: en.institution,
      media: en.media,
      notification: en.notification,
      onboarding: en.onboarding,
      patient: en.patient,
      practitioner: en.practitioner,
      profile: en.profile,
      subscription: en.subscription,
      'admin-user': en.adminUser,
      'admin-institution': en.adminInstitution,
      'app-version': en.appVersion,
    },
    [Language.FR]: {
      common: fr.common,
      agent: fr.agent,
      auth: fr.auth,
      changelog: fr.changelog,
      evaluation: fr.evaluation,
      institution: fr.institution,
      media: fr.media,
      notification: fr.notification,
      onboarding: fr.onboarding,
      patient: fr.patient,
      practitioner: fr.practitioner,
      profile: fr.profile,
      subscription: fr.subscription,
      'admin-user': fr.adminUser,
      'admin-institution': fr.adminInstitution,
      'app-version': fr.appVersion,
    },
  },
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: true,
  },
  nsSeparator: ':',
  keySeparator: '.',
  detection: {
    order: ['cookie', 'navigator'],
    lookupCookie: 'app-locale',
    caches: ['cookie'],
  },
});

export { default } from 'i18next';
